import {h} from 'preact';
import React, {createPortal} from 'preact/compat';
import { useState } from 'preact/hooks';
import store from '../store';
import { setImportWebsiteModal, goToView } from '../actions';
import DataManagerService from '../service/DataManagerService';
import CommentHeartIcon from './icon/CommentHeartIcon';
import MegaphoneIcon from './icon/MegaphoneIcon';
import WebIcon from './icon/WebIcon';
import LineChartIcon from './icon/LineChartIcon';
import DollarCircleIcon from './icon/DollarCircleIcon';
import constants from '../constants';
import * as actions from '../actions';
import util from '../util';

export default function ImportFromWebsite(props) {
  const [url, setUrl] = useState("www.mistaquitos.nyc/menu");
  const [importing, setImporting] = useState(false);
  const [step, setStep] = useState(1);

  async function fetch() {
    if (!url) return;

    setImporting(true);
    const resp = await DataManagerService.getPopMenuItems(url);
    const json = await resp.json();
    window.localStorage.setItem("activeImportSections", JSON.stringify(json));
    window.localStorage.setItem("activeImportUrl", url);
    setImporting(false);

    hide();

    store.dispatch(goToView("templates"));
    util.nextTick(() => {
      store.dispatch(goToView("text-plain"));
    });
  }

  function hide() {
    store.dispatch(setImportWebsiteModal(false));
    store.dispatch(actions.setIsLeftMenuVisible(true));
  }

  return !props.open ? null : <div className={"revenue-wizard"} onClick={hide}>
    <div className={"wrapper"}>
      <header onClick={ev => ev.stopPropagation()}>
        <div className={"wrp"}>
          <h3>Revenue Wizard</h3>
          <ul className={"steps"}>
            <li className={step > 0 ? "sel" : ""}>
              <span className={"crc"}>1</span>
              <label>Intro</label>
            </li>
            <li className={`sep ${step > 0 ? "sel" : ""}`}>
              <hr/>
            </li>
            <li className={`sep ${step > 3 ? "sel" : ""}`}>
              <span className={"crc"}>2</span>
              <label>Setup</label>
            </li>
            <li className={`sep ${step > 3 ? "sel" : ""}`}>>
              <hr/>
            </li>
            <li className={`sep ${step > 4 ? "sel" : ""}`}>
              <span className={"crc"}>3</span>
              <label>Optimize</label>
            </li>
          </ul>
        </div>
      </header>

      <section onClick={ev => ev.stopPropagation()}>
        {step === 1 && <div className={"pg"}>
          <CommentHeartIcon/>
          <h2>Use <u><i>every dish</i></u> on <br/>this menu to capture<br/>reviews and likes</h2>
        </div>}
        {step === 2 && <div className={"pg"}>
          <MegaphoneIcon/>
          <h2>So each dish <br/>acts as a marketing <br/>powerhouse</h2>
        </div>}
        {step === 3 && <div className={"pg"}>
          <WebIcon/>
          <h2>With its own busy<br/>web page gathering<br/>customer data</h2>
        </div>}
        {step === 4 && <div className={"pg"}>
          <LineChartIcon/>
          <h2>To grow traffic while<br/>increasing orders and<br/>repeat business</h2>
        </div>}
        {step === 5 && <div className={"pg"}>
          <DollarCircleIcon/>
          <h2>Then factored back<br/>into this menu to<br/>optimize profits</h2>
        </div>}
        {step === 6 && <div className={"pg"}>
          <img src={constants.appPrefix + '/image/pop-mhm.png'} alt="pop" />
          <h2>Take your menu<br/>engineering to the<br/>next level.</h2>
          <button className={"btn primary"} onClick={() => setStep(step + 1)}>Import your menu</button>
        </div>}
        {step === 7 && <div className={"pg"}>
          <h2>Enter your website URL</h2>
          <div className="content">
            <input value={url} onChange={ev => setUrl(ev.target.value)}/>
            <div>
              <a className={"btn primary medium"} onClick={fetch} style={{ margin: "15px 0 0 0" }}>
                {importing ? "Getting your data..." : "Import"}
              </a>
            </div>
          </div>
        </div>}

        {(step > 0 && step < 6) && <footer>
          {step > 1 && <button className={"prev"} onClick={() => setStep(step - 1)}>‹ Back</button>}
          <button className={"next"} onClick={() => setStep(step + 1)}>Next ›</button>
        </footer>}
      </section>
    </div>
  </div>
}
